import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useBranding } from '../contexts/BrandingContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { orgSlug } = useBranding();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center" style={{ height: '100vh' }}>
        <div className="spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search + location.hash);
    const orgParam = orgSlug ? `&org=${orgSlug}` : '';
    return <Navigate to={`/login?redirect=${redirect}${orgParam}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
